import { useAmp } from 'next/amp';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Logger from '@lmig/dotcom-utilities-helpers/logger';
import IconLoading from './IconLoading';
import DynamicIcons from './iconChunks';

const logger = new Logger('client:components:Icon:LmdsIcons');

// eslint-disable-next-line react/jsx-no-useless-fragment
const emptyIcon = () => <></>;

const LmdsIcon = ({ icon = '', ...rest }) => {
  const isAmp = useAmp();
  const [shouldBeLoaded, setShouldBeLoaded] = useState(isAmp);
  let CurrentIcon;

  if (!(icon in DynamicIcons)) {
    logger.warn(`Cannot find ${icon} icon.`);
    CurrentIcon = emptyIcon;
  } else {
    CurrentIcon = DynamicIcons[icon];
  }

  return shouldBeLoaded ? (
    <CurrentIcon {...rest} />
  ) : (
    <IconLoading onInView={() => !shouldBeLoaded && setShouldBeLoaded(true)} {...rest} />
  );

};

LmdsIcon.propTypes = {
  icon: PropTypes.string,
};

export default LmdsIcon;
